export default __webpack_public_path__ + "locales/ar-SA/Common.json?hash=32a9bdf38905be27ece2e912f2fce550";